import React from 'react';
import PropTypes from 'prop-types';
import './icon.scss';

const AppIcon = ({ icon: IconSource, size = 'md', className = '', ...props }) => {
   if (!IconSource) return null;

   const renderIcon = () => {
      if (React.isValidElement(IconSource)) {
         return IconSource;
      }
      if (typeof IconSource === 'function' || (typeof IconSource === 'object' && IconSource !== null)) {
         return <IconSource />;
      }
      return null;
   };

   return (
      <i className={`ct-icon ct-${size} ${className}`} {...props}>
         {renderIcon()}
      </i>
   );
};

AppIcon.propTypes = {
   icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.object]),
   size: PropTypes.string,
   color: PropTypes.string,
   className: PropTypes.string,
};

export default AppIcon;
